import { formatPhone } from '@if/core/utils'
import PhoneIcon from '@mui/icons-material/Phone'
import { IconButton, Link, Tooltip, Typography } from '@mui/material'

interface PhoneNumberProps {
  phone: string
  phoneExt?: string
  applyPhoneFormatting: boolean
  contacts?: string[]
  enableGoogleSearch?: boolean
}

const PhoneNumber = ({ phone, phoneExt = '', applyPhoneFormatting, contacts, enableGoogleSearch = false }: PhoneNumberProps) => {
  const formattedPhone = applyPhoneFormatting ? formatPhone(phone) : phone
  const telephoneLink = phoneExt ? `tel:${formattedPhone},${phoneExt}` : `tel:${formattedPhone}`
  const contactList = contacts ?? []

  const handleGoogleSearch = () => {
    const searchQuery = phoneExt ? `${formattedPhone} ext ${phoneExt}` : formattedPhone
    const googleUrl = `https://www.google.com/search?q=${encodeURIComponent(searchQuery)}`
    window.open(googleUrl, '_blank', 'noopener,noreferrer')
  }

  const handleClick = enableGoogleSearch ? handleGoogleSearch : undefined
  const linkHref = enableGoogleSearch ? '#' : telephoneLink
  return (
    <Typography>
      {contactList.length > 0 ? (
        <Tooltip
          title={
            <div>
              {contactList.map((contact) => (
                <Typography key={contact} variant="body2">
                  {contact}
                </Typography>
              ))}
            </div>
          }
          arrow
        >
          <IconButton 
            style={{ paddingLeft: '0', cursor: enableGoogleSearch ? 'pointer' : 'default' }}
            onClick={handleClick}
          >
            <PhoneIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton 
          style={{ paddingLeft: '0', cursor: enableGoogleSearch ? 'pointer' : 'default' }}
          onClick={handleClick}
        >
          <PhoneIcon fontSize="small" />
        </IconButton>
      )}
      <Link 
        href={linkHref}
        onClick={handleClick}
        style={{ cursor: enableGoogleSearch ? 'pointer' : 'default' }}
      >
        {formattedPhone} {phoneExt && `ext.${phoneExt}`}
      </Link>
    </Typography>
  )
}

export default PhoneNumber
